import React, { ReactNode, FC, useState, useEffect } from 'react';
import { Connect, PropsFromRedux } from './AddToFoldersFetcherContainer';
import { useUser } from '../../user/useUser';

type Props = {
  children: (props: { isLoading: boolean }) => ReactNode;
} & PropsFromRedux;

const RawAddToFoldersFetcher: FC<Props> = ({ onLoad, children }) => {
  const [isLoading, setLoading] = useState(true);
  const { accessPremium } = useUser();

  useEffect(() => {
    async function loadData() {
      await onLoad();
      setLoading(false);
    }
    if (accessPremium) {
      loadData();
    }
  }, []);

  return <>{children({ isLoading })}</>;
};

export const AddToFoldersFetcher = Connect(RawAddToFoldersFetcher);
